/**
 * Triggers de automação disponíveis no sistema.
 * Cada trigger tem: id, label, category, description, supportsDelay
 */
export const AUTOMATION_TRIGGERS = [
    // ── CAPTAÇÃO ──
    {
        id: "lead_registered",
        label: "Cadastro de Lead",
        category: "Captação",
        description: "Disparada quando um novo lead é cadastrado no sistema",
        icon: "mdi-account-plus",
        supportsDelay: false,
        supportsScheduledTime: false, // Evento imediato
    },
    {
        id: "trial_scheduled",
        label: "Aula Experimental — Aluno",
        category: "Captação",
        description: "Enviada ao aluno quando uma aula experimental é agendada",
        icon: "mdi-calendar-check",
        supportsDelay: false,
        supportsScheduledTime: false, // Evento imediato
    },
    {
        id: "trial_scheduled_teacher",
        label: "Aula Experimental — Professor",
        category: "Captação",
        description: "Enviada ao professor quando uma aula experimental é agendada",
        icon: "mdi-teach",
        supportsDelay: false,
        supportsScheduledTime: false, // Evento imediato
    },
    {
        id: "trial_reminder",
        label: "Lembrete Experimental — Aluno",
        category: "Captação",
        description: "Enviada ao aluno X dias antes da aula experimental",
        icon: "mdi-bell-ring",
        supportsDelay: true,
        delayLabel: "Dias antes da aula",
        supportsScheduledTime: true,
    },
    {
        id: "trial_reminder_teacher",
        label: "Lembrete Experimental — Professor",
        category: "Captação",
        description: "Enviada ao professor X dias antes da aula experimental",
        icon: "mdi-bell-alert",
        supportsDelay: true,
        delayLabel: "Dias antes da aula",
        supportsScheduledTime: true,
    },
    {
        id: "trial_day",
        label: "Dia da Experimental — Aluno",
        category: "Captação",
        description: "Enviada ao aluno no dia da aula experimental",
        icon: "mdi-calendar-clock",
        supportsDelay: false,
        supportsScheduledTime: true,
    },
    {
        id: "trial_day_teacher",
        label: "Dia da Experimental — Professor",
        category: "Captação",
        description: "Enviada ao professor no dia da aula experimental",
        icon: "mdi-account-clock",
        supportsDelay: false,
        supportsScheduledTime: true,
    },


    // ── RETENÇÃO ──
    {
        id: "enrollment_welcome",
        label: "Boas-vindas Matrícula",
        category: "Retenção",
        description: "Disparada X dias após a matrícula (welcome sequence)",
        icon: "mdi-human-greeting",
        supportsDelay: true,
        delayLabel: "Dias após matrícula",
        supportsScheduledTime: true,
    },
    {
        id: "inactive_member",
        label: "Membro Inativo",
        category: "Retenção",
        description: "Disparada quando o membro está X dias sem frequência",
        icon: "mdi-account-off",
        supportsDelay: true,
        delayLabel: "Dias sem frequência",
        supportsScheduledTime: true,
    },

    // ── RELACIONAMENTO ──
    {
        id: "birthday",
        label: "Aniversário",
        category: "Relacionamento",
        description: "Disparada no dia do aniversário do membro",
        icon: "mdi-cake-variant",
        supportsDelay: false,
        supportsScheduledTime: true, // Horário configurável
    },

    // ── RENOVAÇÃO ──
    {
        id: "contract_expiring",
        label: "Contrato Vencendo",
        category: "Renovação",
        description: "Disparada X dias antes do vencimento do contrato",
        icon: "mdi-file-clock",
        supportsDelay: true,
        delayLabel: "Dias antes do vencimento",
        supportsScheduledTime: true,
    },
    {
        id: "contract_expired",
        label: "Contrato Venceu",
        category: "Renovação",
        description: "Disparada no dia do vencimento do contrato",
        icon: "mdi-file-alert",
        supportsDelay: false,
        supportsScheduledTime: false, // Roda entre 00:00-01:00
    },
    {
        id: "contract_renewal",
        label: "Renovação de Contrato",
        category: "Renovação",
        description: "Disparada quando o contrato é renovado",
        icon: "mdi-file-restore",
        supportsDelay: false,
        supportsScheduledTime: false, // Evento imediato
    },

    // ── FINANCEIRO ──
    {
        id: "payment_overdue",
        label: "Pagamento Atrasado",
        category: "Financeiro",
        description: "Disparada quando há pagamento em atraso",
        icon: "mdi-cash",
        supportsDelay: true,
        delayLabel: "Dias de atraso",
        supportsScheduledTime: false, // Roda entre 00:00-01:00
    },

];

/**
 * Canais de envio disponíveis.
 */
export const AUTOMATION_CHANNELS = [
    { id: "whatsapp", label: "WhatsApp", icon: "mdi-whatsapp" },
];

/**
 * Variáveis disponíveis para templates de mensagem.
 */
export const TEMPLATE_VARIABLES = [
    { key: "{memberName}", label: "Nome Completo do Aluno", example: "João Silva" },
    { key: "{firstName}", label: "Primeiro Nome do Aluno", example: "João" },
    { key: "{memberAge}", label: "Idade do Aluno", example: "8" },
    { key: "{tenantName}", label: "Nome da Academia", example: "A2 Aquática" },
    { key: "{teacherName}", label: "Nome do Professor", example: "Carlos Souza" },
    { key: "{date}", label: "Data do Evento", example: "19/03/2026" },
    { key: "{contractEndDate}", label: "Vencimento do Contrato", example: "15/04/2026" },
    { key: "{trialDate}", label: "Data da Aula Experimental", example: "20/03/2026" },
    { key: "{trialTime}", label: "Horário da Aula Experimental", example: "14:30" },
];

/**
 * Categorias de automação para agrupamento visual.
 */
export const AUTOMATION_CATEGORIES = [
    { id: "Captação", icon: "mdi-magnet", color: "#6f42c1" },
    { id: "Retenção", icon: "mdi-shield-account", color: "#0d6efd" },
    { id: "Relacionamento", icon: "mdi-heart", color: "#e83e8c" },
    { id: "Renovação", icon: "mdi-refresh", color: "#fd7e14" },
    { id: "Financeiro", icon: "mdi-cash-multiple", color: "#198754" },
];

/**
 * Valores default para nova automação.
 */
export const initialAutomationValues = {
    trigger: "",
    name: "",
    channel: "whatsapp",
    message: "",
    delayDays: 0,
    scheduledTime: "08:00",
    active: true,
};
